var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.6162C18.9258 19.6162 23.7949 13.9297 23.7949 12.1631C23.7949 10.3965 18.8994 4.70996 12 4.70996C5.16211 4.70996 0.196289 10.3965 0.196289 12.1631C0.196289 13.9297 5.12695 19.6162 12 19.6162ZM12 18.5176C6.02344 18.5176 1.40918 13.4551 1.40918 12.1631C1.40918 11.0029 6.02344 5.80859 12 5.80859C17.9678 5.80859 22.5908 11.0029 22.5908 12.1631C22.5908 13.4551 17.9678 18.5176 12 18.5176ZM12 17.0762C14.7158 17.0762 16.9307 14.8438 16.9307 12.1631C16.9307 9.4209 14.7158 7.25 12 7.25C9.25781 7.25 7.05176 9.4209 7.06055 12.1631C7.07812 14.8438 9.25781 17.0762 12 17.0762ZM12.0088 13.7275C11.1299 13.7275 10.418 13.0244 10.418 12.1631C10.418 11.293 11.1299 10.5986 12.0088 10.5986C12.8701 10.5986 13.582 11.293 13.582 12.1631C13.582 13.0244 12.8701 13.7275 12.0088 13.7275Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.718463d5373673fa683c108e2133357a.svg";
export { ForwardRef as ReactComponent };